import { Dispatch } from "redux";
import {
  authenticationEnablePending,
  authenticationEnable,
  authenticationEnableError,
} from "../redux/actions/AuthenticationSettingAction";
import UserApi from "../api/UserApi";

export function fetchEnableAuthenticationSetting() {
  return (dispatch: Dispatch) => {
    dispatch(authenticationEnablePending());
    UserApi.isAuthenticationEnable()
      .then((authenticationSetting) => {
        dispatch(authenticationEnable(authenticationSetting));
      })
      .catch((error) => {
        dispatch(authenticationEnableError(error));
      });
  };
}